// src/components/WedBanner.js
import React from 'react';
import './WedBanner.css'; // Create or reuse appropriate CSS

const WedBanner = () => {
  return (
    <div className="service-banner text-white d-flex align-items-center">
      <div className="container text-center">
        <h2 className="display-4 fw-bold mt-5">WEDDING MANAGEMENT</h2>
       
      </div>
    </div>
  );
};

export default WedBanner;
